import {
  useReactRouterHandlePopStateEvent,
  BackNavigationController,
  ModalManagerProvider,
} from '@tmap-web-lib/modal-manager'
import { TmapApp } from '@tmap-web-lib/tmap-app-interface'
import { PropsWithChildren, useMemo } from 'react'
import { useBlocker, useLocation, useNavigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

export function GlobalModalManagerProvider({ children }: PropsWithChildren) {
  const navigate = useNavigate()
  const { pathname, search, hash } = useLocation()

  const backNavigationController = useMemo<BackNavigationController>(() => {
    let removeBackPressedListener: () => void
    return {
      onRegisterBackPressedListener: (listener) => {
        removeBackPressedListener = TmapApp.utils.addNativeEventListener<[boolean]>('onBackKeyPressedEvent', blocked => {
          if (!blocked) return
          listener()
        })
      },
      onDeregisterBackPressedListener: () => {
        removeBackPressedListener?.()
      },
      onNeedBlock: () => {
        TmapApp.handleBackKeyEventFromWeb({ handleFromWeb: true })
      },
      onNeedUnblock: () => {
        TmapApp.handleBackKeyEventFromWeb({ handleFromWeb: false })
      },
      onNeedPushState: () => {
        navigate({ pathname, search, hash })
      },
      onNeedPopState: () => {
        navigate(-1)
      },
    }
  }, [hash, navigate, pathname, search])

  return (
    <ModalManagerProvider
      backNavigationController={backNavigationController}
      useHistoryApi={!TmapApp.env.isInApp}
      modalListWrapper={AnimatePresence}
    >
      <ReactRouterPopStateEventListener />
      {children}
    </ModalManagerProvider>
  )
}

function ReactRouterPopStateEventListener() {
  const handlePopStateEvent = useReactRouterHandlePopStateEvent()
  useBlocker(handlePopStateEvent)
  return null
}
